import { render, staticRenderFns } from "./PolicyChartCard.vue?vue&type=template&id=1871cd62&"
import script from "./PolicyChartCard.vue?vue&type=script&lang=js&"
export * from "./PolicyChartCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports